import ContributionInfo from "./Types/ContributionInfoType"

const data: ContributionInfo[] = [
  {
    data: {
      AuthorWorklog: {
        rows: [
          {
            name: "rishsi@devdynamics.ai",
            totalActivity: [
              {
                name: "PR Open",
                value: "1",
              },
              {
                name: "PR Merged",
                value: "1",
              },
              {
                name: "Commits",
                value: "49",
              },
              {
                name: "PR Reviewed",
                value: "19",
              },
              {
                name: "PR Comments",
                value: "4",
              },
              {
                name: "Incident Alerts",
                value: "0",
              },
              {
                name: "Incidents Resolved",
                value: "0",
              },
            ],
            dayWiseActivity: [
              {
                date: "2024-05-06",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "7",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "2",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-07",
                data: {
                  children: [
                    {
                      count: "1",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "7",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "4",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "1",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-08",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "4",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "2",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-09",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "1",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "12",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "1",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-10",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "2",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "3",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-11",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "4",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-12",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "4",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-13",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "5",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "4",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "2",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-14",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "3",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "3",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "1",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-15",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "1",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-16",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-17",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-18",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-19",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
            ],
            activeDays: {
              days: 10,
              isBurnOut: false,
              insight: [""],
            },
          },
          {
            name: "rishi@devdynamics.ai",
            totalActivity: [
              {
                name: "PR Open",
                value: "1",
              },
              {
                name: "PR Merged",
                value: "1",
              },
              {
                name: "Commits",
                value: "49",
              },
              {
                name: "PR Reviewed",
                value: "19",
              },
              {
                name: "PR Comments",
                value: "4",
              },
              {
                name: "Incident Alerts",
                value: "0",
              },
              {
                name: "Incidents Resolved",
                value: "0",
              },
            ],
            dayWiseActivity: [
              {
                date: "2024-05-06",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "7",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "2",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-07",
                data: {
                  children: [
                    {
                      count: "1",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "7",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "4",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "1",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-08",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "4",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "2",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-09",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "1",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "12",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "1",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-10",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "2",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "3",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-11",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "4",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-12",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "4",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-13",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "5",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "4",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "2",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-14",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "3",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "3",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "1",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-15",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "1",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-16",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-17",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-18",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-19",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
            ],
            activeDays: {
              days: 10,
              isBurnOut: false,
              insight: [""],
            },
          },
          {
            name: "ritik@devdynamics.ai",
            totalActivity: [
              {
                name: "PR Open",
                value: "9",
              },
              {
                name: "PR Merged",
                value: "6",
              },
              {
                name: "Commits",
                value: "22",
              },
              {
                name: "PR Reviewed",
                value: "0",
              },
              {
                name: "PR Comments",
                value: "0",
              },
              {
                name: "Incident Alerts",
                value: "0",
              },
              {
                name: "Incidents Resolved",
                value: "0",
              },
            ],
            dayWiseActivity: [
              {
                date: "2024-05-06",
                data: {
                  children: [
                    {
                      count: "1",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "1",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "4",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-07",
                data: {
                  children: [
                    {
                      count: "1",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "1",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "3",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-08",
                data: {
                  children: [
                    {
                      count: "3",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "2",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "5",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-09",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-10",
                data: {
                  children: [
                    {
                      count: "2",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "2",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "6",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-11",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-12",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-13",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-14",
                data: {
                  children: [
                    {
                      count: "1",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "2",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-15",
                data: {
                  children: [
                    {
                      count: "1",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "2",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-16",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-17",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-18",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-19",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
            ],
            activeDays: {
              days: 6,
              isBurnOut: false,
              insight: [""],
            },
          },
          {
            name: "avijit@devdynamics.ai",
            totalActivity: [
              {
                name: "PR Open",
                value: "3",
              },
              {
                name: "PR Merged",
                value: "5",
              },
              {
                name: "Commits",
                value: "18",
              },
              {
                name: "PR Reviewed",
                value: "0",
              },
              {
                name: "PR Comments",
                value: "1",
              },
              {
                name: "Incident Alerts",
                value: "0",
              },
              {
                name: "Incidents Resolved",
                value: "0",
              },
            ],
            dayWiseActivity: [
              {
                date: "2024-05-06",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "1",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-07",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-08",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-09",
                data: {
                  children: [
                    {
                      count: "1",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "1",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "7",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-10",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-11",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-12",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-13",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "1",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "3",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-14",
                data: {
                  children: [
                    {
                      count: "2",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "3",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "7",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-15",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "1",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-16",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-17",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-18",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-19",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
            ],
            activeDays: {
              days: 5,
              isBurnOut: false,
              insight: [""],
            },
          },
          {
            name: "arvind.shelke@devdynamics.ai",
            totalActivity: [
              {
                name: "PR Open",
                value: "2",
              },
              {
                name: "PR Merged",
                value: "1",
              },
              {
                name: "Commits",
                value: "10",
              },
              {
                name: "PR Reviewed",
                value: "0",
              },
              {
                name: "PR Comments",
                value: "0",
              },
              {
                name: "Incident Alerts",
                value: "0",
              },
              {
                name: "Incidents Resolved",
                value: "0",
              },
            ],
            dayWiseActivity: [
              {
                date: "2024-05-06",
                data: {
                  children: [
                    {
                      count: "1",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "1",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "2",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-07",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "1",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-08",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "1",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-09",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "2",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-10",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "1",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-11",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-12",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-13",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-14",
                data: {
                  children: [
                    {
                      count: "1",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "3",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-15",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-16",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-17",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-18",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-19",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
            ],
            activeDays: {
              days: 7,
              isBurnOut: false,
              insight: [""],
            },
          },
          {
            name: "abhijeet@devdynamics.ai",
            totalActivity: [
              {
                name: "PR Open",
                value: "1",
              },
              {
                name: "PR Merged",
                value: "5",
              },
              {
                name: "Commits",
                value: "36",
              },
              {
                name: "PR Reviewed",
                value: "26",
              },
              {
                name: "PR Comments",
                value: "5",
              },
              {
                name: "Incident Alerts",
                value: "0",
              },
              {
                name: "Incidents Resolved",
                value: "0",
              },
            ],
            dayWiseActivity: [
              {
                date: "2024-05-06",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "7",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "2",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-07",
                data: {
                  children: [
                    {
                      count: "1",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "3",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "3",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "1",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-08",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "4",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "2",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-09",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "5",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "2",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "1",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-10",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "2",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "7",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-11",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "4",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-12",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "4",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-13",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "2",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "4",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "2",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-14",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "3",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "3",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "2",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-15",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "5",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-16",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-17",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-18",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
              {
                date: "2024-05-19",
                data: {
                  children: [
                    {
                      count: "0",
                      label: "PR Open",
                      fillColor: "#EF6B6B",
                    },
                    {
                      count: "0",
                      label: "PR Merged",
                      fillColor: "#61CDBB",
                    },
                    {
                      count: "0",
                      label: "Commits",
                      fillColor: "#FAC76E",
                    },
                    {
                      count: "0",
                      label: "PR Reviewed",
                      fillColor: "#C2528B",
                    },
                    {
                      count: "0",
                      label: "PR Comments",
                      fillColor: "#0396A6",
                    },
                    {
                      count: "0",
                      label: "Incident Alerts",
                      fillColor: "#5F50A9",
                    },
                    {
                      count: "0",
                      label: "Incidents Resolved",
                      fillColor: "#8F3519",
                    },
                  ],
                },
              },
            ],
            activeDays: {
              days: 10,
              isBurnOut: false,
              insight: [""],
            },
          },
        ],
      },
    },
  },
]

export default data
